import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Hook to get the font awesome icon size based on the screen size
 * @param belowSmIconName
 * @param aboveSmIconName
 */
var useFontAwesomeIconSize = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.belowSmIconName, belowSmIconName = _c === void 0 ? "fa-sm" : _c, _d = _b.aboveSmIconName, aboveSmIconName = _d === void 0 ? "" : _d;
    var theme = useTheme();
    return useMediaQuery(theme.breakpoints.down("sm")) ? belowSmIconName : aboveSmIconName;
};

export { useFontAwesomeIconSize };
//# sourceMappingURL=index.js.map
